import React from "react";

const MainForm = () => {
    return(
        <div>
            Market research
        </div>
    )
}

export default MainForm